import { render, staticRenderFns } from "./loginCheck.vue?vue&type=template&id=530bdbf1&scoped=true&"
import script from "./loginCheck.vue?vue&type=script&lang=js&"
export * from "./loginCheck.vue?vue&type=script&lang=js&"
import style0 from "./loginCheck.vue?vue&type=style&index=0&id=530bdbf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530bdbf1",
  null
  
)

export default component.exports